import { useLanguage } from "@/context/LanguageContext";
import { footerLabels } from "@/i18n";
import { LegalPoliciesLinks } from "@/components/footer/LegalPoliciesLinks";

const PrivacyPolicies = () => {
  const { language } = useLanguage();
  const labels = footerLabels(language);

  return (
    <div className="container mx-auto min-w-0 max-w-2xl px-4 py-8 pb-16">
      <h1 className="text-2xl font-bold text-center mb-2">
        {labels.privacyDialog?.title ?? labels.privacy}
      </h1>
      <p className="text-sm text-muted-foreground text-center mb-8">
        {labels.privacyPage?.subtitle}
      </p>
      <LegalPoliciesLinks variant="page" showCopyright />
    </div>
  );
};

export default PrivacyPolicies;
